import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { Illumination, IlluminationMode } from '../../types/illumination';

@Component({
  selector: 'frodo-pickup-space-door-indicator',
  templateUrl: './pickup-space-door-indicator.component.html',
  styleUrls: ['./pickup-space-door-indicator.component.scss'],
})
export class PickupSpaceDoorIndicatorComponent {
  @Input() image: SafeUrl | null = null;
  @Input() color: string | null = null;
  @Input() mode: IlluminationMode | null = null;
  @Input() label = 'remotePickup.orderPickup.spaceImageLabel';

  readonly Illumination = Illumination;
}
